// extracted by mini-css-extract-plugin
export default {"logo":"Sidenav_logo__bp56s","sidenavContainer":"Sidenav_sidenavContainer__6dhl0"};